import { render } from "./SearchResultViewer.vue?vue&type=template&id=2f5f8dec&lang=pug"
import script from "./SearchResultViewer.vue?vue&type=script&lang=js"
export * from "./SearchResultViewer.vue?vue&type=script&lang=js"

import "./SearchResultViewer.vue?vue&type=style&index=0&id=2f5f8dec&lang=sass"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QInfiniteScroll from 'quasar/src/components/infinite-scroll/QInfiniteScroll.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QField from 'quasar/src/components/field/QField.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QIcon,QPopupProxy,QScrollArea,QInfiniteScroll,QSpinnerDots,QItem,QChip,QField,QMenu});
